import { createSelector } from 'reselect'
import Immutable from 'immutable'

/**
 * selector create a selector using `reselect`'s createSelector() function.
 * It assumes that the selected state is Immutable, hence it calls toJS() at the end of the selector.
 * @param {*} keys List of nested keys pointing to the particular path of the state to be selected
 */
const selector = (...keys) => () =>
  createSelector(state => state.getIn(keys), state => (Immutable.Iterable.isIterable(state) ? state.toJS() : state))

export default { selector }
